export type AttentionStatus = 'COMPLEX' | 'PROTECTED' | 'UNSUPPORTED';

export type DocumentStatus =
    | AttentionStatus
    | 'DELETED'
    | 'ERROR'
    | 'INDEXED'
    | 'PROCESSING'
    | 'UPLOAD_FAILED'
    | 'UPLOADING';

export type UploadedDocument = {
    readonly id: string;
    readonly createdAt: string;
    readonly name: string;
    readonly status: string;
    readonly updatedAt: string;
};

export const documentNeedsAttention = (status: string): status is AttentionStatus =>
    status === 'PROTECTED' || status === 'COMPLEX' || status === 'UNSUPPORTED';

export type FileToUpload = {
    readonly file: File;
    readonly presignedUrl: string;
};

export const isDocumentStatus = (status: string): status is DocumentStatus => {
    return [
        'UPLOADING',
        'UPLOAD_FAILED',
        'PROCESSING',
        'INDEXED',
        'ERROR',
        'DELETED',
        'PROTECTED',
        'COMPLEX',
        'UNSUPPORTED',
    ].includes(status);
};
